import Cookies from "universal-cookie";
import axios from "axios";
import { teamAwareGet, getCurrentTeamUuid } from "../utils/teamApiHelper";

function getToken() {
    const cookies = new Cookies();
    return cookies.get("token");
}

export function getCreditUsageLogs(params) {
    try {
        const baseUrl = process.env.REACT_APP_API_BASE_URL;
        if (!baseUrl) {
            throw new Error('API base URL is not configured');
        }

        const token = getToken();
        if (!token) {
            throw new Error('Authentication token not found');
        }

        const url = baseUrl + `/credit-usage-logs`;
        
        // Validate params
        if (!params || typeof params !== 'object') {
            throw new Error('Invalid parameters provided');
        }

        // Filter out undefined/null/empty values before creating query params
        const cleanParams = Object.entries(params).reduce((acc, [key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                acc[key] = value;
            }
            return acc;
        }, {});
        
        // Auto-inject team_uuid if not present
        if (!cleanParams.team_uuid) {
            const teamUuid = getCurrentTeamUuid();
            if (teamUuid) {
                cleanParams.team_uuid = teamUuid;
            }
        }

        const queryParams = new URLSearchParams(cleanParams).toString();
        
        return axios.get(`${url}${queryParams ? `?${queryParams}` : ''}`, { 
            headers: { 
                authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            timeout: 30000 // 30 second timeout
        });
    } catch (error) {
        return Promise.reject(error);
    }
}


export function getCreditUsageLogDetail(uuid) {
    const url = process.env.REACT_APP_API_BASE_URL + `/credit-usage-logs/${uuid}`;
    return axios.get(url, { 
        headers: { authorization: `Bearer ${getToken()}` } 
    });
}